module.exports = __webpack_public_path__ + "static/img/instructions.c820a72.png";